import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import SuccessMsg from "../../Messages/SuccessMsg";
import LoadingMsg from "../../Messages/LoadingMsg";
import { Timeout } from "../../functions/functions";
import { useTranslation } from "react-i18next";

interface Props {
  payments: any;
  className: string;
  medecinTypes: any;
  typeMedecin: any;
  setTypeMedecin: any;
  tableType: string;
}

const RenderTable: React.FC<Props> = ({
  payments,
  className,
  medecinTypes,
  typeMedecin,
  setTypeMedecin,
  tableType,
}) => {
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const Message = `
السلام عليكم. 
يذكركم  السلك الوطني لأطباء الأسنان الموريتانيين  بالمبادرة بدفع اشتراككم  و تصحيح وضعيتكم علي لائحة السلك الوطني لأطباء الأسنان الموريتانيين. 
رقم الحساب : 2000334BPM
رقم بنكيلي 36478787 
و لكم جزيل الشكر.
Salam
L'Ordre National des Medecins Dentistes de Mauritanie vous rappelle de procéder au paiement de votre cotisation annuelle et de régulariser votre situation sur le tableau de l'Ordre National des Medecins Dentistes de Mauritanie.

Numéro de compte bancaire : 2000334 BPM
Compte bankily: 36478787

Nous vous remercions grandement.
`;

  const sendWhatsApp = async () => {
    if (tableType === "green") return;


    setLoading(true);

    for (const [index, doctor] of payments.entries()) {
      const phone = doctor?.contact?.whatsapp;

      if (!phone) continue;

      const headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");

      const body = new URLSearchParams();
      body.append("token", "zu4sjyx1b59if1mr");
      body.append("to", phone);
      body.append("body", Message);

      try {
        await fetch("https://api.ultramsg.com/instance73914/messages/chat", {
          method: "POST",
          headers,
          body,
          redirect: "follow",
        });

        if (index === payments.length - 1) {
          setShowSuccessMsg(true);
          setTimeout(() => setShowSuccessMsg(false), Timeout);
        }
      } catch (error) {
        console.error("Error sending WhatsApp:", error);
      }
    }

    setLoading(false);
  };

  return (
    <>
      <SuccessMsg
        modal={showSuccessMsg}
        toggle={() => setShowSuccessMsg(false)}
      />
      {loading && <LoadingMsg modal={loading} toggle={() => {}} />}

      {/* Doctor Type Selector */}
      <div className="flex flex-col md:flex-row md:items-center md:gap-6 gap-4 mb-6">
        <p className="text-base font-medium text-gray-700">
          {t("Type de médecin")}
        </p>
        <div className="flex flex-wrap gap-3">
          {medecinTypes.map((medecin: any) => (
            <label
              key={medecin._id}
              htmlFor={medecin?.title}
              className={`flex items-center gap-2 px-4 py-1.5 rounded-lg border cursor-pointer transition
              ${
                typeMedecin === medecin?.title
                  ? "bg-blue-100 border-blue-500 text-blue-700"
                  : "bg-white border-gray-300 hover:border-blue-400"
              }
            `}
            >
              <input
                type="radio"
                id={medecin?.title}
                name="medecintype"
                value={medecin?.title}
                checked={typeMedecin === medecin?.title}
                onChange={() => setTypeMedecin(medecin?.title)}
                className="form-radio text-blue-600 focus:ring-blue-500"
              />
              <span className="capitalize">{medecin?.title}</span>
            </label>
          ))}
        </div>
      </div>

      {/* WhatsApp Button */}
      {tableType !== "green" && (
        <div className="mb-4">
          <button
            onClick={sendWhatsApp}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md transition"
          >
            <FaWhatsapp className="text-2xl" />
            Envoyer un message WhatsApp
          </button>
        </div>
      )}

      {/* Data Table */}
      <div className="overflow-x-auto rounded-lg shadow">
        <table className="min-w-full divide-y divide-gray-200 border border-gray-300 text-sm">
          <thead className="bg-main text-white">
            <tr>
              <th className="px-6 py-3 text-left font-semibold uppercase tracking-wider border-r border-gray-300">
                Matricule
              </th>
              <th className="px-6 py-3 text-left font-semibold uppercase tracking-wider">
                Nom
              </th>
            </tr>
          </thead>
          <tbody className={className}>
            {payments.length === 0 ? (
              <tr>
                <td colSpan={2} className="px-6 py-4 text-center text-gray-500">
                  Aucun médecin trouvé
                </td>
              </tr>
            ) : (
              payments.map((doctor: any, index: number) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100`}
                >
                  <td className="px-6 py-4 border-r border-gray-300 font-medium">
                    {doctor?.RegNo + "/" + (doctor?.medecinType?.title ?? "")}
                  </td>
                  <td className="px-6 py-4">{doctor?.fullName}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RenderTable;
